module.exports = __webpack_public_path__ + "public/SiteIcons/selectedLightIcon.svg?5b228620";